/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import PageTitle from "components/atoms/PageTitle";
import GameModeButtonsConainer from "containers/organisms/GameModeButtonsConainer";
import ButtonFavoriteContainer from "containers/atoms/ButtonFavoriteContainer";
import BangerPreloader from "assets/json/banger_game_preloader.json";
import GloryPreloader from "assets/json/glory_game_preloader.json";

// Hooks
import { useLoadGame } from "hooks/useLoadGame";
import { GAME_MODE, GameType } from "types/Games";
import CloseIcon from "assets/icons/close-grey.svg?react";

// Selectors
import { makeLangUrl } from "helpers/makeLangUrl";

import SEOH1 from "utils/helmet/components/SEOH1";
import { checkCountry } from "utils/checkVPN";
import "./styles.sass";
import { useRouterHistoryStore } from "stores/routerHistory";
import { useAuthStore } from "stores/auth";
import * as authSelectors from "redux/auth/selectors";
import { useSelector } from "react-redux";
import { VPNNotification } from "components/atoms/VPNNotification";
import { useCheckBalance } from "hooks/useCheckBalance";
import * as userSelectors from "redux/user/selectors";
import url from "../../../../url";

type GamePageProps = {
  currentGame: GameType | null;
  gameUrl: string;
  mode: GAME_MODE;
  gameAlias: string;
  reset: () => any;
};

const GamePage = (props: GamePageProps) => {
  const { currentGame, gameUrl, mode, gameAlias, reset } = props;
  const navigate = useNavigate();
  const [loadGame, { isLoading, isError }] = useLoadGame();
  const [isLoaderProcess, setIsLoaderProcess] = useState(false);
  const [isVPN, setIsVPN] = useState(false);
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const checkBalance = useCheckBalance();
  const userData = useSelector(userSelectors.all);
  const previousPage = useRouterHistoryStore((state) => state.previous);

  const isAuthCheck = useAuthStore((state) => state.isAfterAuthCheck);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const handleCheckVPN = async () => {
    const VPNCheck = await checkCountry(userData);
    setIsVPN(VPNCheck);
  };
  useEffect(() => {
    if (mode !== GAME_MODE.DEMO) {
      if (isAuthCheck) {
        const isBalancePositive = checkBalance();
        if (isBalancePositive) {
          loadGame(mode, gameAlias);
        }
      }
    } else {
      loadGame(mode, gameAlias);
    }
    return () => reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthCheck, mode, isAuthenticated]);

  useEffect(() => {
    if (
      !isLoading &&
      (currentGame?.provider?.name === "Evolution" ||
        currentGame?.provider?.name === "Evolution2")
    ) {
      handleCheckVPN();
      setTimeout(() => {
        setIsVPN(false);
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, currentGame]);

  useEffect(() => {
    if (isError) {
      navigate(makeLangUrl(url.routes.casino.index()));
    }
  }, [isError, navigate]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoaderProcess(true);
    }, 2000);
  }, []);
  const handleBack = () => {
    navigate(previousPage);
  };

  const preloader =
    VITE_APP_PROJECT_NAME === "banger" ? BangerPreloader : GloryPreloader;
  return (
    <div className="GamePage">
      <div className="GamePage__header">
        <PageTitle
          titleComponent={
            <SEOH1 title={(currentGame && currentGame.name) || ""} />
          }
          backText="popup.payment.error.back"
          onBack={handleBack}
        />

        <div className="GamePage__header_controls">
          {currentGame &&
            currentGame.provider &&
            currentGame.provider.hasDemo && <GameModeButtonsConainer />}
          <ButtonFavoriteContainer />
          <button
            type="button"
            className="GamePage__header_close"
            onClick={() => navigate(makeLangUrl("/"))}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className="GamePage__content">
        {isLoading || !isLoaderProcess ? (
          <div className="GamePage__loader">
            <Lottie animationData={preloader} loop={false} />
          </div>
        ) : (
          <>
            <VPNNotification isVPN={isVPN} />
            <iframe
              src={gameUrl}
              allowFullScreen
              title="game"
              className={`${isVPN ? "blurred" : ""}`}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default GamePage;
